// extracted by mini-css-extract-plugin
export default {"fixed":"fixed_El60N"};